Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _Spacing = require('./Spacing');

var _Spacing2 = _interopRequireDefault(_Spacing);

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _textlike2['default'].isRequired,
  after: _propTypes2['default'].node,
  before: _propTypes2['default'].node,
  centered: _propTypes2['default'].bool,
  inline: _propTypes2['default'].bool,
  spaceBetween: _propTypes2['default'].number,
  verticalAlign: _propTypes2['default'].oneOf(['middle', 'top'])
}));

var defaultProps = {
  after: null,
  before: null,
  centered: false,
  inline: false,
  spaceBetween: 1,
  verticalAlign: 'middle'
};

function Labeled(_ref) {
  var css = _ref.css,
      after = _ref.after,
      before = _ref.before,
      centered = _ref.centered,
      children = _ref.children,
      inline = _ref.inline,
      spaceBetween = _ref.spaceBetween,
      styles = _ref.styles,
      verticalAlign = _ref.verticalAlign;

  var margin = centered ? '0 auto' : null;
  var childStyles = [styles.child, inline && styles.child_inline, !inline && verticalAlign === 'middle' && styles.child_vaMiddle, !inline && verticalAlign === 'top' && styles.child_vaTop];
  return _react2['default'].createElement(
    'div',
    css(inline ? styles.container_inline : styles.container, { margin: margin }),
    before && _react2['default'].createElement(
      'div',
      css(childStyles),
      _react2['default'].createElement(
        _Spacing2['default'],
        { right: spaceBetween },
        before
      )
    ),
    _react2['default'].createElement(
      'div',
      css(childStyles),
      children
    ),
    after && _react2['default'].createElement(
      'div',
      css(childStyles),
      _react2['default'].createElement(
        _Spacing2['default'],
        { left: spaceBetween },
        after
      )
    )
  );
}

Labeled.componentCategory = 'Core';
Labeled.displayName = 'Labeled';
Labeled.propTypes = propTypes;
Labeled.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    container: {
      display: 'table'
    },

    container_inline: {
      display: 'inline-block'
    },

    child: {
      display: 'table-cell'
    },

    child_inline: {
      display: 'inline-block'
    },

    child_vaMiddle: {
      verticalAlign: 'middle'
    },

    child_vaTop: {
      verticalAlign: 'top'
    }
  };
})(Labeled);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Labeled.js
// module id = 27
// module chunks = 168707334958949